<template>
  <v-navigation-drawer
    id="primary-nav"
    v-model="primaryNavVisible"
    :width="width"
    :style="navStyles"
    fixed
    dark
    app
    clipped
    floating
    class="primary-nav elevation-3"
    mobile-break-point="1024"
  >
    <accounts-list />
  </v-navigation-drawer>
</template>

<script>
  import primaryNavMixin from '@/mixins/primary_nav'
  import ErrorGeneric from '@/components/common/ErrorGeneric'

  export default {
    mixins: [primaryNavMixin],
    components: {
      AccountsList: () => ({
        component: import(/* webpackChunkName: "list-index" */ '@/components/list/Index'),
        error: ErrorGeneric,
        timeout: 3000
      })
    },
    computed: {
      width () {
        return this.$vuetify.breakpoint.xsOnly ? window.innerWidth : '300'
      },
      navStyles () {
        // Default behavior puts the nav on top of the app toolbar for small viewports
        return {
          maxHeight: `calc(100% - ${this.$vuetify.application.top}px)`,
          marginTop: `${this.$vuetify.application.top}px`
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/core/AppPrimaryNav.vue